import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import * as Sentry from "@sentry/react";
import { errorMessage } from 'helpers/common';

// Accepts the include string, or { include, background } for interval polls
// that must not move the ready flag.
const fetchBudgetSettings = createAsyncThunk('fetchBudgetSettings', async (arg, { rejectWithValue }) => {
  const { include, background = false } = typeof arg === 'object' && arg !== null ? arg : { include: arg };

  try {
    var apiUrl = '/settings/budgets';

    if (include) apiUrl += `?include=${include}`;

    const { data, status } = await api.get(apiUrl, { meta: { background } });
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch budget setting'));
  }
});

const saveBudgetSetting = createAsyncThunk('saveBudgetSetting', async (formData, { rejectWithValue }) => {
  try {
    const { data, status } = await api.post('/settings/budgets', formData);
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'save budget setting'));
  }
});

export const budgetSettingsSlice = createSlice({
  name: 'budgetSettings',
  initialState: {
    budgets: null,
    error: null
  },
  reducers: {
    updateError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveBudgetSetting.fulfilled, (state, action) => {
        state.error = null;
      })
      .addCase(saveBudgetSetting.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchBudgetSettings.fulfilled, (state, action) => {
        state.error = null;
        state.budgets = action.payload.data;
      })
      .addCase(fetchBudgetSettings.rejected, (state, action) => {
        state.error = action.payload;
      });

  }
});

export const getBudgetSettingsError = (state) => state.budgetSettings.error;
export const getBudgetSettings = (state) => state.budgetSettings.budgets;

export { fetchBudgetSettings, saveBudgetSetting };

export const { updateError } = budgetSettingsSlice.actions;

export default budgetSettingsSlice.reducer;
